/* eslint-disable no-unused-vars */
import { get } from "lodash";
import { axiosPublic, axiosPrivate } from ".";
import store from "../store";

export const getStore = () => {
  return store.getters.storeSequencial;
};

export const getEvent = idevento =>
  axiosPrivate.post(
    `loja/produto/listar/evento/resumo/${idevento}`,
    {
      loja: getStore(),
    },
    {
      cache: true,
    }
  );

export const getCheckIn = idproduto =>
  axiosPrivate.post(
    `checkin/fluxo_checkin`,
    {
      loja: getStore(),
      idproduto: idproduto,
    },
    {
      cache: true,
    }
  );

export const salesByTicketDash = (idproduto, filters, exportType) =>
  axiosPrivate.post(
    "relatorio/loja/produto/dash",
    {
      loja: getStore(),
      idproduto: idproduto,
      ...filters,
      exportation: exportType,
    },
    { cache: true, responseType: exportType ? "arraybuffer" : "json" }
  );
